import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import api from '../lib/api';
import { formatINR, formatDate } from '../lib/format';

export default function Quotations() {
  const [items, setItems] = useState([]);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { api.get('/quotations').then(r => setItems(r.data)); }, []);
  // Group by lineage (parent_id or self id)
  const lineages = {};
  items.forEach(q => {
    const key = q.parent_id || q.id;
    if (!lineages[key]) lineages[key] = [];
    lineages[key].push(q);
  });
  const rows = Object.values(lineages).map(vs => {
    vs.sort((a, b) => (b.version || 1) - (a.version || 1));
    const current = vs.find(v => v.is_current) || vs[0];
    return { current, versions: vs };
  });
  const visible = showAll ? rows : rows;
  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-5xl mx-auto">
      <div className="flex items-center justify-between mb-5">
        <div><div className="eyebrow">Quotations</div><h1 className="serif text-[28px]">Quotations</h1></div>
        <Link to="/quotations/new" className="btn-gold" data-testid="quotation-new-btn"><Plus size={16}/> New</Link>
      </div>
      <div className="space-y-2">
        {visible.length === 0 && <div className="card-cream p-8 text-center text-sm text-[var(--muted)] italic">No quotations yet.</div>}
        {visible.map(({ current: q, versions }) => (
          <Link to={`/quotations/${q.id}`} key={q.id} className="card-cream p-4 block hover:bg-[var(--cream-alt)]" data-testid={`quotation-${q.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="serif text-[19px]">{q.number} · {q.client_name}</div>
                <div className="text-xs text-[var(--muted)] mt-1 flex gap-2 flex-wrap items-center">
                  <span>v{q.version}</span>
                  {versions.length > 1 && <span>({versions.length} versions)</span>}
                  <span>·</span>
                  <span>{q.event_groups?.length || q.events_snapshot?.length || 0} event{(q.event_groups?.length || q.events_snapshot?.length || 0)===1?'':'s'}</span>
                  <span>·</span>
                  <span>{formatDate(q.created_at)}</span>
                  {(q.view_count||0) > 0 && <span className="text-[var(--gold)]">· {q.view_count} view{q.view_count===1?'':'s'}</span>}
                </div>
              </div>
              <div className="text-right">
                <div className="serif mono-num">{formatINR(q.total)}</div>
                <span className={`status-pill status-${q.status==='accepted'?'ok':q.status==='lost'||q.status==='expired'?'overdue':'pending'}`}>{q.status}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
